import React, { useEffect } from 'react'
import { StyleSheet, View } from 'react-native'
import Animated, { useSharedValue, useAnimatedStyle, withTiming, interpolate, Easing } from 'react-native-reanimated'
import { scheduleOnRN } from 'react-native-worklets'
import { useMutation } from 'convex/react'
import { api } from '@ppwr/convex/_generated/api'

import { DS } from '@/design-system'

import { useStore as useMobXStore } from '@/models'

import * as cth from '@/router/(root)/cth/cthModule'
import * as d10 from '@/router/(root)/daily10/d10Module'
import * as pocketPick from '@/router/(root)/pocketPick/pocketPickModule'

import { defaultTheme } from '@/components/Mini/theme'

import Diamond from '@/assets/diamonds/Diamond.svg';

type DiamondsData = ReturnType<typeof pocketPick.usePocketPickQueryDiamonds>

function PocketPickDiamondsCard() {
  const data = pocketPick.usePocketPickQueryDiamonds()
  const theme = pocketPick.useStore(s => s.theme)

  return (
    <DiamondsCard data={data} T={theme} />
  )
}

function CthDiamondsCard() {
  const data = cth.useCthQueryDiamonds()
  const theme = cth.useStore(s => s.theme)

  return (
    <DiamondsCard data={data} T={theme} />
  )
}

function D10DiamondsCard() {

  const data = d10.useD10QueryDiamonds()
  const theme = d10.useStore(s => s.theme)

  return (
    <DiamondsCard data={data} T={theme} />
  )
}


function DiamondsCard({ data, T=defaultTheme }: { data: DiamondsData; T?: typeof defaultTheme }) {

  const { events, diamonds } = data

  const { session: { isAdmin, isSuperAdmin } } = useMobXStore()

  const cardBackgroundColor = T.surface
  const cardBorderColor = T.surfaceBorder
  const titleTextColor = T.accent

  if (!isAdmin && !isSuperAdmin){
    return null
  }

  

  const markDiamondEventsSeen = useMutation(api.diamonds.mutations.markDiamondEventsSeen)
  function markSeen(unseenIds: any[]){
    markDiamondEventsSeen({ transactionIds: unseenIds })
  }

  const duration = 3; //s
  const start = 0;
  const mid = duration / 2;
  const end = duration;

  const diamondProgress = useSharedValue(0);
  
  const diamondAnimationStyle = useAnimatedStyle(() => ({
        zIndex: 1,
        transform: [
          { scale: interpolate(diamondProgress.value, [start, mid, end], [1, 2, 1]) },
          { rotate: `${interpolate(diamondProgress.value, [start, mid, end], [0, 360, 720])}deg` }
        ]
      }));
      
  

  useEffect(function (){

    const unseenIds = events?.filter((event) => !event.seen).map((event) => event._id) ?? []

    function animateDiamond(){
      let d = duration*1000
      diamondProgress.value = withTiming(
        duration,
        { duration: d, easing: Easing.elastic(1)},
        function (){
          scheduleOnRN(markSeen, unseenIds)
        }
      )
    }
    
    if (unseenIds.length > 0){
      animateDiamond();
    }
  }, [events])



  return (
    <View style={[styles.card, { backgroundColor: cardBackgroundColor, borderColor: cardBorderColor }]}>

      <View style={[styles.titleContainer, {flexDirection:"row", gap:8, justifyContent: "center"}]}>
        <DS.Text style={[styles.titleContainerText, styles.titleText, { color: titleTextColor }]} variant="Heading 3/Medium">
          + {diamonds} 
        </DS.Text>
        <Animated.View style={diamondAnimationStyle}>
          {/*<Diamond height="120%" style={{top: -1.5}}/>*/}
          <Diamond height="30" style={{top: -1.5}}/>
        </Animated.View>
        <DS.Text style={[styles.titleContainerText, styles.titleText, { color: titleTextColor }]} variant="Heading 3/Medium">
          Diamonds Earned
        </DS.Text>
      </View>

    </View>

  )
}

const styles = StyleSheet.create({
  card: {
    borderRadius: 16,
    borderWidth: 1,
    padding: 20,
    gap: 20
  },
  titleContainer: {
    alignItems: 'center',
    gap: 4
  },
  titleContainerText: {
    textAlign: 'center'
  },
  titleText: {
    lineHeight: 30
    //lineHeight:0
  },
})


export { CthDiamondsCard, D10DiamondsCard, PocketPickDiamondsCard }
export default DiamondsCard
